export default "__VITE_ASSET__658ac8f5__"